// extracted by mini-css-extract-plugin
module.exports = {"logo":"CardCarriersCombined-module__logo___IOeh2"};